export default __webpack_public_path__ + "static/media/boisestate-primarylogo.757d2893.svg";